import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.oysterTheme.charcoal,
      borderRadius: 8,
      '&:hover fieldset': {
        borderColor: `${theme.oysterTheme.oyster} !important`,
      },
    },
    select: {
      '&:focus': {
        backgroundColor: theme.oysterTheme.cotton,
        outline: 0,
      },
    },
    item: {
      fontSize: '1rem !important',
      color: `${theme.oysterTheme.extraGrey} !important`,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fontWeight: `${500} !important`,
    },
  }),
);

export default useStyles;
